/* Quali dati mostrare mentre se ne caricano di nuovi.
 *
 * Durante un caricamento si tiene la pagina di prima, attenuata: i comandi non spariscono sotto le dita.
 * Dopo un errore no. Il caricamento fallito e' per una selezione nuova (un altro periodo, un altro
 * cliente) e i numeri rimasti sono della selezione di prima: mostrarli di nuovo a colori pieni, sotto i
 * filtri nuovi, li fa leggere come numeri di quella selezione. E' lo stesso principio di `carica.ts`: un
 * errore non diventa mai dati, ne' vuoti ne' vecchi (controllo del 19 ottobre 2026).
 */
export function datiDaMostrare<T>(attuali: T | undefined, ultimi: T | undefined, errore: string | null): T | undefined {
  if (attuali !== undefined) return attuali;
  return errore ? undefined : ultimi;
}
